import React from 'react';

import { CalendarOutlined } from '@ant-design/icons';
import { DatePicker, Typography } from 'antd';
import { ColumnGroupType } from 'antd/es/table';
import { Dayjs } from 'dayjs';

interface Props {
  onTimeChange: (arg: Dayjs) => void;
  onTimeClick?: (time: string) => void;
  activeTimeList?: string[];
}

function TableTimePicker<TableData>({ onTimeChange, onTimeClick, activeTimeList = [] }: Props): ColumnGroupType<TableData> {
  return (
    {
      children: [{
        width: 58,
        fixed: 'left',
        dataIndex: 'startTime',
        render: (bookingTime: string, _, index: number) => (
          <div
            onClick={() => onTimeClick ? onTimeClick(bookingTime) : null}
            style={{
              position: 'absolute',
              bottom: '100%',
              transform: 'translateY(50%)',
              backgroundColor: activeTimeList.some((time) => time === bookingTime) ? 'rgba(200, 80, 190, 0.2)' : 'white',
              borderRadius: '8px',
              padding: '0px 2px',
              border: '1px solid #f0f0f0',
              cursor: 'pointer'
            }}
          >
            {index !== 0 && (
              <Typography.Text>
                {bookingTime.split('T')[1].slice(0, 5)}
              </Typography.Text>
            )}
          </div>
        )
      }],
      title: () => (
        <DatePicker
          className='hideDatePickerPlaceholder'
          placeholder=''
          onChange={onTimeChange}
          style={{ padding: '4px 0px' }}
          suffixIcon={
            <div style={{ position: 'absolute', left: '50%', top: '50%', transform: 'translate(-50%,-50%)' }}>
              <CalendarOutlined />
            </div>
          }
        />
      ),
    }
  );
}

export default TableTimePicker;
